<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import ButtonAlt from "@/dsComponents/buttons/ButtonAlt.vue";
import Modal from "@/dsComponents/modals/Modal.vue";

interface CancelUpcomingMissionsModalProps {
    open: boolean;
    workerName?: string;
    isMultipleWorkers?: boolean;
    isLoading?: boolean;
}

const props = defineProps<CancelUpcomingMissionsModalProps>();

const emit = defineEmits<{
    close: [];
    "skip-cancel": [];
    "cancel-missions": [];
}>();

const { t } = useI18n();

const description = computed(() =>
    props.isMultipleWorkers
        ? t("modals.removeDeactivatedGroupFromMission.description")
        : t("modals.removeDeactivatedInterimFromMission.description", { name: props.workerName ?? "" })
);
</script>

<template>
    <Modal
        class="cancel-upcoming-missions-modal"
        width="500px"
        :title="t('modals.removeDeactivatedInterimFromMission.title')"
        :open="open"
        action
        @close="emit('close')"
    >
        <span class="typo-xm-regular cancel-upcoming-missions-modal__description" v-html="description" />

        <template #footer>
            <div class="cancel-upcoming-missions-modal__footer">
                <ButtonAlt
                    type="neutral"
                    variant="ghost"
                    :label="t('modals.inactiveInterim.action.doNotCancel')"
                    :loading="isLoading"
                    @click="emit('skip-cancel')"
                />
                <ButtonAlt
                    type="error"
                    variant="filled"
                    :label="t('modals.inactiveInterim.action.cancelMissions')"
                    :loading="isLoading"
                    @click="emit('cancel-missions')"
                />
            </div>
        </template>
    </Modal>
</template>

<style scoped lang="scss">
.cancel-upcoming-missions-modal {
    &__description {
        color: var(--text-sub-600, #636778);
    }

    &__footer {
        display: flex;
        justify-content: flex-end;
        gap: var(--spacing-lg, 12px);
    }
}
</style>
